if (!customElements.get('campaign-countdown')) {
  customElements.define('campaign-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      // A frame also allows children to finish parsing when inserted by the editor.
      this.frame = requestAnimationFrame(() => this.start());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.stop();
    }

    stop() {
      clearInterval(this.interval);
    }

    start() {
      this.values = Array.from(this.querySelectorAll('[data-countdown-value]'));
      this.waiting = this.querySelector('[data-countdown-waiting]');
      this.started = this.querySelector('[data-countdown-started]');
      this.before = this.querySelector('[data-countdown-before]');
      this.after = this.querySelector('[data-countdown-after]');
      this.timer = this.querySelector('[role="timer"]');
      if (this.values.length !== 4 || !this.timer) return;

      const date = this.dataset.date.trim();
      const time = this.dataset.time.trim();
      const offset = this.dataset.offset.trim();
      const iso = `${date}T${time}:00${offset}`;
      this.target = Date.parse(iso);
      // Reject invalid calendar dates instead of silently rolling into next month.
      const calendar = new Date(`${date}T00:00:00Z`);
      const valid = /^\d{4}-\d{2}-\d{2}$/.test(date)
        && /^([01]\d|2[0-3]):[0-5]\d$/.test(time)
        && /^[+-](0\d|1[0-4]):[0-5]\d$/.test(offset)
        && (!/^[+-]14:/.test(offset) || offset.endsWith(':00'))
        && Number.isFinite(this.target)
        && Number.isFinite(calendar.getTime())
        && calendar.toISOString().slice(0, 10) === date;

      const notice = this.querySelector('[data-countdown-error]');
      if (notice) notice.hidden = valid;
      this.classList.toggle('campaign-countdown--invalid', !valid && Boolean(notice));
      this.previewStarted = Boolean(window.Shopify?.designMode) && this.dataset.previewStarted === 'true';
      if (!valid && !this.previewStarted) {
        this.waiting.hidden = true;
        this.started.hidden = true;
        this.before.hidden = false;
        this.after.hidden = true;
        return;
      }

      this.update();
      if (!this.finished) this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      this.finished = this.previewStarted || remaining <= 0;
      this.waiting.hidden = this.finished;
      this.started.hidden = !this.finished;
      this.before.hidden = this.finished;
      this.after.hidden = !this.finished;
      if (this.finished) {
        this.stop();
        return;
      }

      const units = [
        Math.floor(remaining / 86400),
        Math.floor((remaining % 86400) / 3600),
        Math.floor((remaining % 3600) / 60),
        remaining % 60
      ];
      this.values.forEach((element, index) => {
        const value = String(units[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
      this.timer.setAttribute('aria-label', units.map((value, index) =>
        `${value} ${this.values[index].dataset.label}`
      ).join(', '));
    }
  });
}
